import { render } from "./VEDIO.vue?vue&type=template&id=63a65f81&scoped=true"
import script from "./VEDIO.vue?vue&type=script&lang=js"
export * from "./VEDIO.vue?vue&type=script&lang=js"

import "./VEDIO.vue?vue&type=style&index=0&id=63a65f81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a65f81"]])

export default __exports__